blogsHandler  = {
    $buttonPageBack = $('[href="#page-back"]'),
    $buttonPageNext = $('[href="#page-next"]'),
    $buttonPage = $('[href="#page"]'),
    $maxPage = $('.panel-blogs-pagination').data('max-page'),
    $contentBubble = $('.bubble-link'),
    $pageNum = $('.page-num'),

    nextBackPage = function($state='next') {        
        $currPage = $('.page-num.is-current');
        $pageId = $currPage.data('page-id');

        if ($state == 'next') {
            $pageId++;
        } else if ($state == 'back') {
            $pageId--;
        }

        $otherPage = $('.page-num[data-page-id='+$pageId+']');
        $otherPage.click();
    },

    init = function() {
        var self = this;

        self.$buttonPageBack.on('click', function(e) {
            e.preventDefault();
            self.nextBackPage('back');
        });

        self.$buttonPageNext.on('click', function(e) {
            e.preventDefault();
            self.nextBackPage('next');
        });

        self.$buttonPage.on('click', function(e) {
            $pageId = $(this).data('page-id');

            self.$pageNum.removeClass('is-current');
            $(this).addClass('is-current');

            self.$contentBubble.addClass('hide');
            $('.bubble-link[data-page-id='+$pageId+']').removeClass('hide');

            self.$buttonPageBack.removeClass('hide');
            self.$buttonPageNext.removeClass('hide');

            if ($pageId == 1) {
                self.$buttonPageBack.addClass('hide');
            }
            
            if ($pageId == self.$maxPage) {
                self.$buttonPageNext.addClass('hide');
            }
        });
    }
}